import { render, staticRenderFns } from "./registration-brand-segment.page.vue?vue&type=template&id=d1be13ba&scoped=true"
import script from "./registration-brand-segment.page.vue?vue&type=script&lang=ts"
export * from "./registration-brand-segment.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1be13ba",
  null
  
)

export default component.exports